import React, { useEffect, useState } from "react";
import styles from "../TriggerField.module.scss";
import { TextField } from "@mui/material";
import { CustomDropdown } from "components/shared/customDropdown";
import HighlightOffIcon from "@mui/icons-material/HighlightOff";
import { useDispatch, useSelector } from "react-redux";
import { setDroppedItems } from "@redux/slices/triggerSlice";
import { setPublish } from "@redux/slices/globalSlice";

const optionsArray = [

    { label: "checked", value: "checked" },
    { label: "not checked", value: "not checked" },
];

const CheckboxTrigger = ({ item }) => {
    const { triggerDroppedList } = useSelector((state) => state?.trigger);
    const [localOptions, setLocalOptions] = useState(item?.trigger || { label: "Checkbox", options: "checked" });

    const dispatch = useDispatch();

    const handleChange = (name, value) => {
        setLocalOptions((prev) => {
            let updatedOptions = { ...prev, [name]: value };

            if (name === "options") {
                if (value === "checked" || value === "not checked") {
                    updatedOptions = {
                        ...updatedOptions,
                        value: "",
                    };
                } else {
                    updatedOptions = {
                        ...updatedOptions,
                        value: ""
                    };
                }
            }

            return updatedOptions;
        });
    };

    const handleDelete = () => {
        const filteredDroppedItems = triggerDroppedList?.filter((e) => e?.id !== item?.id);
        dispatch(setDroppedItems(filteredDroppedItems));
        dispatch(setPublish(true))
    };

    useEffect(() => {
        const updatedTriggerList = triggerDroppedList?.map((e) => {
            if (e?.id === item?.id) {
                return {
                    ...e,
                    optionLabel: item?.label || "Checkbox",
                    trigger: { ...localOptions },
                };
            }
            return e;
        });
        dispatch(setDroppedItems(updatedTriggerList));
    }, [localOptions]);

        useEffect(() => {
            setLocalOptions((prev) => ({
                ...prev,
                options: item?.operator || prev.options
            }));
        }, [item?.operator]);

    return (
        <div className={styles?.metaContainer}>
            <div className={styles?.field}>
                <TextField value={item?.label || "Checkbox"} disabled name="label" />

                <CustomDropdown
                    width='200px'
                    name="options"
                    options={optionsArray}
                    value={localOptions?.options || ""}
                    onChange={(e) => handleChange(e?.target?.name, e?.target?.value)}
                />
            </div>


            <div
                style={{ display: "flex", alignItems: "center", cursor: "pointer" }}
                onClick={handleDelete}
            >
                <HighlightOffIcon />
            </div>
        </div>
    );
};

export default CheckboxTrigger;
